import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

type HookProps = {
  clientToken: string;
  site: string;
  env: string;
  service: string;
  applicationId: string;
  version?: string;
};

type ReturnTuple = [
  (user: { [id: string]: string }) => void,
  () => void,
  (service: string) => void,
  (message: string, type: 'info' | 'warn' | 'error', context: object, error?: Error) => void,
];

function useDatadog({ applicationId, clientToken, site, env, service, version }: HookProps): ReturnTuple {
  console.group('datadog env:', env);

  if (env !== undefined && env !== 'undefined') {
    console.info({ applicationId, clientToken, site, service, version });

    datadogLogs.init({
      clientToken,
      site,
      env,
      service,
      forwardErrorsToLogs: true,
      silentMultipleInit: true,
      sampleRate: 100,
      version,
    });

    datadogRum.init({
      applicationId,
      clientToken,
      site,
      env,
      service,
      trackResources: true,
      trackLongTasks: true,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100, // if not included, the default is 100
      silentMultipleInit: true,
      sampleRate: 100,
      trackUserInteractions: true,
      trackFrustrations: true,
      version,
    });

    datadogRum.startSessionReplayRecording();

    return [
      (user) => {
        datadogLogs.setUser(user);
        datadogRum.setUser(user);
      },
      () => {
        datadogLogs.clearUser();
        datadogRum.clearUser();
      },
      (newService) => {
        datadogLogs.setGlobalContextProperty('service', newService);
        datadogRum.setGlobalContextProperty('service', newService);
      },
      (message, type, context, error) => {
        if (type === 'info') {
          datadogLogs.logger.info(message, context, error);
        } else if (type === 'warn') {
          datadogLogs.logger.warn(message, context, error);
        } else if (type === 'error') {
          datadogLogs.logger.error(message, context, error);
        }
      },
    ];
  }

  console.groupEnd();

  return [() => {}, () => {}, () => {}, () => {}];
}

export default useDatadog;
